export default "__VITE_ASSET__36c11155__"